import { ScheduleKind } from "../../../app/backendTypes";
import { useScheduledTask } from "../../../app/hooks";
import Error from "../Error";
import Loading from "../Loading";
import TaskView from "./TaskView";

export default function ScheduledTask(props: { schedule: ScheduleKind }) {
  const { schedule } = props;

  const { task, error, loading, reload } = useScheduledTask(schedule);

  if (loading) return <Loading />;
  if (error) return <Error error={error} />;

  return (
    <>{task !== null && <TaskView task={task} callback={reload} expanded />}</>
  );
}
